import React from "react";
import Styles from "./Styles.module.css";
import Slider6 from "./programsliders/Slider6";
import SkeletonDisplay from "../hooks/skeletonDisplay";

function HealthFocusingonHIVAIDSandDrugAbuse() {
  return (
    <div>
      <div className={Styles.slider1}>
        <div className={Styles.mainContainer}>
          <SkeletonDisplay>
            <img src="/aboutus/aboutus.png" alt="Curd Africa" />
          </SkeletonDisplay>
          <button>Health Focusing on HIV/AIDS and Drug Abuse</button>
        </div>
      </div>
      <div style={{ margin: "0 auto" }}>
        <Slider6 />
      </div>
    </div>
  );
}

export default HealthFocusingonHIVAIDSandDrugAbuse;
